import React from 'react';

export const COUNTRIES = [
  { code: 'chile', name: 'Chile', flag: '🇨🇱', currency: 'CLP' },
  { code: 'argentina', name: 'Argentina', flag: '🇦🇷', currency: 'ARS' },
  { code: 'mexico', name: 'México', flag: '🇲🇽', currency: 'MXN' },
  { code: 'colombia', name: 'Colombia', flag: '🇨🇴', currency: 'COP' },
  { code: 'peru', name: 'Perú', flag: '🇵🇪', currency: 'PEN' },
  { code: 'ecuador', name: 'Ecuador', flag: '🇪🇨', currency: 'USD' },
];

export const GLOBAL_COUNTRIES = [
  ...COUNTRIES,
  { code: 'brasil', name: 'Brasil', flag: '🇧🇷', currency: 'BRL' },
  { code: 'espana', name: 'España', flag: '🇪🇸', currency: 'EUR' },
  { code: 'eeuu', name: 'EE.UU.', flag: '🇺🇸', currency: 'USD' },
];

export const money = (n, currency) =>
  n == null ? '—' : new Intl.NumberFormat('es-CL', { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);

export const inputCls = 'w-full rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:border-rose-400 focus:outline-none';

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mb-1 block text-xs font-medium uppercase tracking-wider text-slate-400">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-slate-500">{hint}</span>}
  </label>
);

export const CountrySelect = ({ value, onChange, testId = 'country-select', options = COUNTRIES }) => (
  <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className={inputCls}>
    {options.map((c) => (
      <option key={c.code} value={c.code}>{c.flag} {c.name}</option>
    ))}
  </select>
);

export const LegalFooter = ({ basis, disclaimer }) => (
  <div className="mt-4 space-y-1 border-t border-slate-800 pt-3 text-xs text-slate-400">
    <p data-testid="legal-basis"><span className="font-semibold text-slate-300">Base legal:</span> {basis}</p>
    <p className="italic">{disclaimer}</p>
  </div>
);
